// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './generated/routes/_app'
import { Route as AppIndexRouteImport } from './generated/routes/_app/index'
import { Route as AppSettingsRouteImport } from './generated/routes/_app/settings'
import { Route as AppReviewRouteImport } from './generated/routes/_app/review'
import { Route as AppReportingRouteImport } from './generated/routes/_app/reporting'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSettingsRoute = AppSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppRoute
          })
const AppReviewRoute = AppReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => AppRoute
          })
const AppReportingRoute = AppReportingRouteImport.update({
            id: '/reporting',path: '/reporting',getParentRoute: () => AppRoute
          })





const AppRouteChildren = {
  AppReportingRoute: AppReportingRoute,AppReviewRoute: AppReviewRoute,AppSettingsRoute: AppSettingsRoute,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)